module.exports = __webpack_public_path__ + "img/no-img.099896c3.jpg";